export const drawer = {
  root: {
    background: "{surface.bg-grey}",
    borderColor: "{overlay.modal.border.color}",
    color: "{overlay.modal.color}",
    shadow: "{overlay.modal.shadow}",
  },
  header: {
    padding: "{overlay.modal.padding}",
  },
  title: {
    fontSize: "{typography.card.heading.font.size}",
    fontWeight: "{typography.card.heading.font.weight}",
  },
  content: {
    padding: "{overlay.modal.padding}",
  },
  footer: {
    padding: "{overlay.modal.padding}",
  },
  extend: {
    ui: {
      header: {
        gap: "{gap.16}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-drawer {
      overflow-y: auto;
      max-width: 100vw;
    }

    .p-drawer-header {
      gap: ${dt("drawer.ui.header.gap")};
    }
  `,
};
